import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import BlogsnNews from "./pages/BlogsnNews";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blogs-and-news" element={<BlogsnNews />} />
      </Routes>
    </Router>
  );
}

export default App;
